



















































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { get, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { errorToMessage } from '@/core/utils/errors';
//import HMSwitch from '../common/HMSwitch.vue';

export default Vue.extend({
  components: {
    ValidationObserver,
    //HMSwitch,
  },
  props: {
    link: {
      type: Object,
      default() {
        return {
          id: null,
          image: null,
          label: null,
          link: null,
          position: null,
          active: true,
        };
      },
    },
  },
  data() {
    return {
      linkModel: {},
      formError: null,
    };
  },
  computed: {
    ...mapGetters({ bioLinks: 'setting/bioLinks' }),
  },
  methods: {
    async submitLink() {
      const dispatchAction = this.link.id
        ? 'setting/updateBioLink'
        : 'setting/addBioLink';
      try {
        await this.$store.dispatch(dispatchAction, {
          id: this.linkModel?.id,
          ...formatObjectForBackend(cloneDeep(this.linkModel)),
        });
        await this.$store.dispatch('setting/getMarvelousBioInfo');
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response),
        });
      }
    },
  },
  mounted() {
    if (this.link.position === null) {
      this.link.position = this.bioLinks?.length ? this.bioLinks.length : 0;
    }
    this.linkModel = cloneDeep(this.link);
  },
});
